import {Component, OnInit} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import {MatAnchor} from "@angular/material/button";
import {ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";

import {NgxSpinnerService} from "ngx-spinner";
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {HttpClient} from "@angular/common/http";
import {Endpoints} from "../../../endpoints";
@Component({
  selector: 'app-clients-exploitation-details',
  standalone: true,
    imports: [
        CommonModule, MatCardModule, RouterOutlet, MatAnchor, RouterLink, RouterLinkActive
    ],
    providers: [Endpoints],
  templateUrl: './clients-exploitation-details.component.html',
  styleUrl: './clients-exploitation-details.component.scss'
})
export class ClientsExploitationDetailsComponent implements OnInit{
    clientId: string = '';
    exploitationList : any;
    constructor(        private route: ActivatedRoute,
                        private spinner: NgxSpinnerService,
                        private endPoints : Endpoints,
                        public themeService: CustomizerSettingsService,
                        private http : HttpClient) {
    }
    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.clientId = params.get('id') || '';
            if (this.clientId) {
                this.fetchClientDetails(this.clientId)
            }
        });
    }

    fetchClientDetails(clientId: string) {
        this.spinner.show();
        const clientUrl = `${this.endPoints.client_exploitation_base_endpoint}/${clientId}`;

        console.log(`${clientUrl}/${clientId}`)

        this.http.get<any>(clientUrl).subscribe(
            {
                next : data => {
                    
            if (data.status) {
                console.log('✅ Status OK, données reçues:', data.data);
                console.log('Nombre d\'exploitations:', data.data?.length ?? 0);
                this.exploitationList = data.data;
                console.log('exploitationList mise à jour:', this.exploitationList);
           } else {
                console.warn('⚠️ Status false ou absent, exploitationList non mise à jour');
                console.warn('Réponse data complète:', data);
            }

            this.spinner.hide();
        },
                error : err => console.log(err)
            }
        )
    }
    onEdit() {

    }

    onDelete() {

    }
}
